import { useEffect, useRef, useState } from 'react';
import type { AutocompleteOption } from 'shared/search/types';
import type { Filters } from '@/domain';
import { dateOrNull, populateDestination } from '../utils/searchUtils';

export const useSearchFormState = (filters: Filters, initialQuery?: Record<string, unknown>) => {
    const initialFilters: Filters = initialQuery ?? filters;
    const [fromDate, setFromDate] = useState(dateOrNull(initialFilters.booking_from ?? ''));
    const [toDate, setToDate] = useState(dateOrNull(initialFilters.booking_to ?? ''));
    const [destination, setDestination] = useState<AutocompleteOption | null>(populateDestination(initialFilters));
    const [bedrooms, setBedrooms] = useState(Number(initialFilters.no_of_bedrooms_from) || 0);
    const [beds, setBeds] = useState(Number(initialFilters.no_of_beds_from) || 0);
    const isInitialMountRef = useRef(true);

    useEffect(() => {
        if (isInitialMountRef.current) {
            isInitialMountRef.current = false;
            return;
        }
        setFromDate(dateOrNull(filters.booking_from ?? ''));
        setToDate(dateOrNull(filters.booking_to ?? ''));
        setDestination(populateDestination(filters));
        setBedrooms(Number(filters.no_of_bedrooms_from) || 0);
        setBeds(Number(filters.no_of_beds_from) || 0);
    }, [filters]);

    return {
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        destination,
        setDestination,
        bedrooms,
        setBedrooms,
        beds,
        setBeds,
    };
};
